import React from "react";
import styled from "styled-components";

const ARROW_SVG_CLASSNAME = "arrow-svg";

/**
 * SVG for arrow pictogram.
 */
export const arrowSvg = (
  <svg
    className={ARROW_SVG_CLASSNAME}
    width="65"
    height="35"
    viewBox="0 0 65 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M47.2699 18.2001C47.6572 17.8101 47.6571 17.1806 47.2697 16.7907L35.2773 4.72048C34.6482 4.08738 33.5679 4.53283 33.5679 5.4253V10.243L18.0293 10.243C17.477 10.243 17.0293 10.6907 17.0293 11.243V17.4953V23.7477C17.0293 24.2999 17.477 24.7477 18.0293 24.7477L33.5679 24.7477V29.5736C33.5679 30.4662 34.6485 30.9116 35.2775 30.2782L47.2699 18.2001Z"
      fill="url(#paint0_linear_935_43268)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_935_43268"
        x1="16.9889"
        y1="17.5336"
        x2="47.9294"
        y2="17.5336"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#45FF00" stopOpacity="0" />
        <stop offset="0.05" stopColor="#FFCC00" stopOpacity="0" />
        <stop offset="0.3" stopColor="#FFCC00" stopOpacity="0.5" />
        <stop offset="0.9" stopColor="#FFCC00" />
        <stop offset="1" stopColor="#FFCC00" />
      </linearGradient>
    </defs>
  </svg>
);

export const Root = styled("div")({
  display: "none",

  [`@media screen and (min-width: 48rem)`]: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "calc(var(--dui-size-space-20x)) var(--dui-size-space-4x) 0",
    width: 64,
  },
});

export const Arrow = styled("button")({
  appearance: "none",
  background: "var(--dui-colors-background-base)",
  border: 0,

  [`.${ARROW_SVG_CLASSNAME}`]: {
    transition: "transform 0.2s ease-in-out",
  },

  "&:hover": {
    cursor: "pointer",

    [`.${ARROW_SVG_CLASSNAME}`]: {
      transform: "rotate(180deg)",
    },
  },
});

export const Line = styled("div")({
  background: "var(--dui-components-navigation-stroke-secondary)",
  height: "calc(50% - 35px)",
  width: 1,
});
